// /assets/green-custom-js.js

(function () {
  const KEY = 'green_hide_variant_flag';
  const HIDE_TEXT = '5 mL';

  function hasTriggerInUrl() {
    const params = new URLSearchParams(window.location.search);
    // Trigger if either parameter exists
    return params.get('sample') === 'none' || params.get('pricing') === 'full';
  }

  function shouldHide() {
    return sessionStorage.getItem(KEY) === '1' || hasTriggerInUrl();
  }

  function setPersistFlagFromUrl() {
    if (hasTriggerInUrl()) {
      sessionStorage.setItem(KEY, '1');
    }
  }

  function normalizeText(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }

  function optionLooksLike5ml(optionEl) {
    const t = normalizeText(optionEl?.textContent || optionEl?.innerText || optionEl?.value);
    return t === HIDE_TEXT || t.startsWith(HIDE_TEXT + ' ') || t.includes(HIDE_TEXT);
  }

  function labelLooksLike5ml(labelEl) {
    const t = normalizeText(labelEl?.textContent || labelEl?.innerText);
    return t === HIDE_TEXT || t.startsWith(HIDE_TEXT + ' ') || t.includes(HIDE_TEXT);
  }

  function hide5mlEverywhere() {
    if (!shouldHide()) return;

    // 1) Hide radio/button variant pickers by label text
    document.querySelectorAll('label[for]').forEach(label => {
      if (!labelLooksLike5ml(label)) return;

      const id = label.getAttribute('for');
      if (!id) return;

      const input = document.getElementById(id);
      if (input && input.type === 'radio') {
        input.disabled = true;
        input.checked = false;
        input.style.display = 'none';
      }

      label.style.display = 'none';
    });

    // 2) Hide dropdown options
    document.querySelectorAll('select').forEach(select => {
      let needsReset = false;

      Array.from(select.options).forEach(opt => {
        if (!optionLooksLike5ml(opt)) return;

        opt.disabled = true;
        opt.hidden = true;
        opt.style.display = 'none';

        if (opt.selected) needsReset = true;
      });

      if (needsReset) {
        const firstValid = Array.from(select.options).find(o => !o.disabled && !o.hidden);
        if (firstValid) {
          select.value = firstValid.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  // Persist flag as early as possible
  setPersistFlagFromUrl();

  // Run immediately and after short delays for dynamic content
  hide5mlEverywhere();
  setTimeout(hide5mlEverywhere, 50);
  setTimeout(hide5mlEverywhere, 250);

  // Re-run on relevant events
  document.addEventListener('change', hide5mlEverywhere);
  document.addEventListener('variant:change', hide5mlEverywhere);
  document.addEventListener('product:change', hide5mlEverywhere);
  document.addEventListener('product-info:change', hide5mlEverywhere);
  document.addEventListener('shopify:section:load', hide5mlEverywhere);

  // Handle browser navigation (back/forward)
  window.addEventListener('popstate', function () {
    setPersistFlagFromUrl();
    hide5mlEverywhere();
    setTimeout(hide5mlEverywhere, 50);
  });

  // Monkey-patch history.pushState / replaceState
  ['pushState', 'replaceState'].forEach(fn => {
    const orig = history[fn];
    if (typeof orig !== 'function') return;

    history[fn] = function () {
      const ret = orig.apply(this, arguments);
      setPersistFlagFromUrl();
      hide5mlEverywhere();
      setTimeout(hide5mlEverywhere, 50);
      return ret;
    };
  });

  // Observe DOM changes
  let rafPending = false;
  const observer = new MutationObserver(() => {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      hide5mlEverywhere();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();